/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 19:59:48
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-08-31 13:54:16
 * @name: 会话存储
 * @Description: 会话存储, 关闭浏览器标签清除
 * @FilePath: \preSaleNafterSaleBackstage\src\storage\session.js
 * @Author: DESKTOP-1QU67QM
 */
const session = class {
    constructor() {

    }
}

export default session;